angular.module('offlineChecker')
    .filter('checkinFilter', checkinFilter);

function checkinFilter() {
    return function (reservations, checkinDateIndex, checkoutDateIndex, searchFor) {
        if (!Array.isArray(reservations)) {
            return reservations;
        }
        if (reservations.length === 0) {
            return reservations;
        }
        if (checkinDateIndex >= reservations[0].length) {
            return reservations;
        }
        if (checkoutDateIndex >= reservations[0].length) {
            return reservations;
        }
        if (!(checkinDateIndex >= 0)) {
            return reservations;
        }
        if (!(checkoutDateIndex >= 0)) {
            return reservations;
        }
        checkinDateIndex -= (checkinDateIndex % 1); // fix for floats being passed in
        checkoutDateIndex -= (checkoutDateIndex % 1);
        var out = [];
        angular.forEach(reservations, function (reservation) {
            var searchAgainstIn = reservation[checkinDateIndex];
            var searchAgainstOut = reservation[checkoutDateIndex];
            searchFor = parseInt(searchFor);
            switch(searchFor){
                case 0: // pending
                    if(searchAgainstIn === null){
                        out.push(reservation);
                    }
                    break;
                case 1: // checkin
                    if(searchAgainstIn !== null && searchAgainstOut === null){
                        out.push(reservation);
                    }
                    break;
                case 2: // checkout
                    if(searchAgainstIn !== null && searchAgainstOut !== null){
                        out.push(reservation);
                    }
                    break;
                default:
                    out.push(reservation);
                    break;
            }
        });
        return out;
    };
}
